export const CheckRequestData = [
  {
    id: 1,
    code: "99160205",
    name: "امیر حسین رستمی",
    title: "ترمیم انتخاب واحد",
    state: "برسی نشده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 2,
    code: "98151502",
    name: "حسین موسوی",
    title: "پرداخت شهریه",
    state: "برسی نشده",
    attachment: "ضمیمه ندارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 3,
    code: "98158609",
    name: "الهام صمدی",
    title: "حذف درس",
    state: "برسی نشده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 4,
    code: "9958098",
    name: "امیر حسین قربانی",
    title: "ترمیم انتخاب واحد",
    state: "برسی نشده",
    attachment: "ضمیمه ندارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 5,
    code: "1400985",
    name: "بهاره امین نیا",
    title: "ثبت نام با تاخیر",
    state: "برسی نشده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 6,
    code: "98110606",
    name: "نگار رستمی",
    title: "نرمیم انتخاب واحد",
    state: "برسی نشده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 7,
    code: "99160295",
    name: "رضا تقی زاده",
    title: "ترمیم انتخاب واحد",
    state: "برسی نشده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
];

export const AllStudentListData = [
  {
    id: 1,
    code: "99160205",
    name: "امیر حسین رستمی",
    grade: "کارشناسی",
    field: "صنایع"
  },
  {
    id: 2,
    code: "98151502",
    name: "حسین موسوی",
    grade: "کارشناسی ارشد",
    field: "کامپیوتر"
  },
  {
    id: 3,
    code: "98158609",
    name: "الهام صمدی",
    grade: "کارشناسی",
    field: "کامپیوتر"
  },
  {
    id: 4,
    code: "9958098",
    name: "امیر حسین قربانی",
    grade: "کارشناسی",
    field: "کامپیوتر"
  },
  {
    id: 5,
    code: "1400985",
    name: "بهاره امین نیا",
    grade: "کارشناسی ارشد",
    field: "عمران"
  },
  {
    id: 6,
    code: "98110606",
    name: "نگار رستمی",
    grade: "کارشناسی",
    field: "کامپیوتر"
  },
  {
    id: 7,
    code: "99160295",
    name: "رضا تقی زاده",
    grade: "کارشناسی",
    field: "مکانیک"
  },
];

export const CheckedRequestData = [
  {
    id: 1,
    code: "99160205",
    name: "امیر حسین رستمی",
    title: "ترمیم انتخاب واحد",
    state: "برسی شده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 2,
    code: "98151502",
    name: "حسین موسوی",
    title: "پرداخت شهریه",
    state: "برسی شده",
    attachment: "ضمیمه ندارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 3,
    code: "98158609",
    name: "الهام صمدی",
    title: "حذف درس",
    state: "برسی شده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 4,
    code: "9958098",
    name: "امیر حسین قربانی",
    title: "ترمیم انتخاب واحد",
    state: "برسی شده",
    attachment: "ضمیمه ندارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 5,
    code: "1400985",
    name: "بهاره امین نیا",
    title: "ثبت نام با تاخیر",
    state: "برسی شده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 6,
    code: "98110606",
    name: "نگار رستمی",
    title: "نرمیم انتخاب واحد",
    state: "برسی شده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
  {
    id: 7,
    code: "99160295",
    name: "رضا تقی زاده",
    title: "ترمیم انتخاب واحد",
    state: "برسی شده",
    attachment: "ضمیمه دارد",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Eye.svg",
      "/Assets/Images/Trash.svg",
      "/Assets/Images/Gallery.svg",
    ],
  },
];

export const AllRequestData = [
    {
      id: 1,
      code: "#RS45896",
      title: "ترمیم انتخواب واحد",
      to: "مدیر گروه",
      state: "ارسال شده",
      stateCode: 1,
      attachment: "ضمیمه دارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 2,
      code: "#RS35231",
      title: "ثبت نام با تاخیر",
      to: "مدیر آموزش",
      state: "در حال برسی",
      stateCode: 2,
      attachment: "ضمیمه ندارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 3,
      code: "#RS35210",
      title: "واریز شهریه",
      to: "حسابداری",
      state: "پاسخ داده شده",
      stateCode: 3,
      attachment: "ضمیمه ندارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 4,
      code: "#RS35200",
      title: "ترمیم انتخواب واحد",
      to: "مدیر گروه",
      state: "پاسخ داده شده",
      stateCode: 3,
      attachment: "ضمیمه دارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 5,
      code: "#RS39568",
      title: "ترمیم انتخواب واحد",
      to: "مدیر گروه",
      state: "پاسخ داده شده",
      stateCode: 3,
      attachment: "ضمیمه دارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 6,
      code: "#RS39568",
      title: "ترمیم انتخواب واحد",
      to: "مدیر گروه",
      state: "پاسخ داده شده",
      stateCode: 3,
      attachment: "ضمیمه دارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
    {
      id: 7,
      code: "#RS39568",
      title: "ترمیم انتخواب واحد",
      to: "مدیر گروه",
      state: "پاسخ داده شده",
      stateCode: 3,
      attachment: "ضمیمه دارد",
      buttonImg: [
        "/Assets/Images/Document.svg",
        "/Assets/Images/Eye.svg",
        "/Assets/Images/Close.svg",
        "/Assets/Images/Export.svg",
        "/Assets/Images/Gallery.svg",
      ],
    },
];
export const AllEmployeesData = [
  {
    id: 1,
    name: "محسن ابوکاظم پور",
    res: "مدیر کل آموزش و تحصیلات تکمیلی",
    state: "غیر فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 2,
    name: "فاطمه محسنی",
    res: "مسئول پرونده‌های تحصیلی و بایگانی",
    state: "فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 3,
    name: "سیده نوریه میرحسینی",
    res: "رئیس دفتر ریاست،روابط عمومی و امور بین...",
    state: "غیر فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 4,
    name: "روح الله پورشعبان اوشیبی",
    res: "رئیس اداره پشتیبانی و مسئول جمعدار اموال",
    state: "فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 5,
    name: "محبوبه نریمان",
    res: "سرپرست سایت کامپیوتر و کتابخانه",
    state: "فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 6,
    name: "عبدالعلی صمیمی",
    res: "کارشناس فرهنگی",
    state: "غیر فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
  {
    id: 7,
    name: "امید مهرداد",
    res: "کارشناس امور دانش آموختگان و نظام وظیفه",
    state: "فعال",
    buttonImg: [
      "/Assets/Images/Edit.svg",
      "/Assets/Images/Trash.svg",
    ],
  },
];

